import { SVGProps } from 'react';

const Profico = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="63" height="63" x=".5" y=".5" fill="url(#a)" rx="31.5" />
    <rect width="63" height="63" x=".5" y=".5" stroke="#1F1F1F" rx="31.5" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M35.226 16c3.484 0 6.236 1.01 8.3 2.985 2.108 1.975 3.14 4.609 3.14 7.901s-1.032 5.926-3.14 7.945c-2.107 1.976-4.86 2.985-8.3 2.985h-6.925V48h-6.967V16h13.892Zm-.947 6.32H28.3v9.438h5.979c3.355 0 5.032-1.58 5.032-4.784 0-3.117-1.677-4.653-5.032-4.653Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient id="a" x1="64" x2="19.498" y1="0" y2="75.494" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F1F1F" />
        <stop offset="1" stopColor="#141414" />
      </linearGradient>
    </defs>
  </svg>
);

export default Profico;
